<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-领取记录
      -->
  <div class="user">


    <div class="product-content">
      <el-form ref="form" :model="form" class="el-form demo-form-inline el-form--inline">
        <!--搜索表单-->
        <div class="common-seach-wrap">
         <el-form-item  label="优惠券记录ID"><el-input size="small" v-model="couponId" placeholder="优惠券ID"></el-input></el-form-item>
          <el-form-item  label="用户编号/名称"><el-input size="small" v-model="userName" placeholder="请输入用户编号/名称"></el-input></el-form-item>
          <el-form-item  label="订单编号"><el-input size="small" v-model="orderNo" placeholder="请输入订单编号"></el-input></el-form-item>
          <el-form-item  label="优惠券ID"><el-input size="small" v-model="oldCouponId" placeholder="请输入优惠券ID"></el-input></el-form-item>

          <el-form-item  ><el-button size="small" type="primary" icon="el-icon-search" @click="getData()">查询</el-button></el-form-item>
        </div>
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="userId" label="用户ID"></el-table-column>

            <el-table-column prop="nickname" label="用户昵称"></el-table-column>
            <el-table-column prop="userCouponId" label="优惠券记录ID"></el-table-column>
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
            <el-table-column prop="couponId" label="优惠券ID"></el-table-column>

            <el-table-column prop="sendType" label="领券类型">
              <template slot-scope="scope">
                <div v-if="scope.row.sendType==0">
                  <span>后台推送 </span>
                </div>
                <div v-if="scope.row.sendType==1">
                  <span>用户领取</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="isUse" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.isUse==0">
                  <span>未使用</span>
                </div>
                <div v-if="scope.row.isUse==1">
                  <span>已使用</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="couponType" label="优惠券类型"></el-table-column>
            <el-table-column prop="minPrice" label="最低消费金额"></el-table-column>
            <el-table-column prop="seckillStock" label="优惠方式">
              <template slot-scope="scope">
                <div v-if="scope.row.couponType==10">
                  <span>立减 <strong class="orange">{{scope.row.reducePrice}}</strong> 元</span>
                </div>
                <div v-if="scope.row.couponType==20">
                  <span>打 <strong class="orange">{{scope.row.discount}}</strong> 折</span>
                </div>
                <div v-if="scope.row.couponType==30">
                  <span>立减 <strong class="orange">{{scope.row.reducePrice}}</strong> 元</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="seckill_stock" label="有效期">
              <template slot-scope="scope">
                <div v-if="scope.row.expireType==10">
                  <span>领取 <strong class="orange">{{scope.row.expireDay}}</strong> 天内有效</span>
                </div>
                <div v-if="scope.row.expireType==20">
                  <span>
                    {{scope.row.startTimeText}}
                    ~
                    {{scope.row.endTimeText}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="领取时间"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import CouponApi from '@/api/coupon.js';
  export default {
    data() {
      return {
        formInline: {},
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        couponId:null,
        userName:null,
        orderNo:null,
        oldCouponId:null,
        /*是否加载完成*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        Params.couponId = self.couponId;
        Params.userName = self.userName;
        Params.oldCouponId = self.oldCouponId;


        Params.orderNo = self.orderNo;

        CouponApi.receiveList(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.records;
            self.totalDataNumber = res.data.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      }
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/Receive.vue